<template>
<div class="signup-form-wrapper">
  <div class="signup-form">
    <input
      v-model="email"
      :placeholder="__('Your email...')"
      class="signup-email"
      @keyup="enter"
      ref="inputField"
      >
    <el-button
      @click="subscribe"
      >
      {{__('Follow us')}}
    </el-button>
  </div>

  <line-loader v-if="isPending" style="margin-top: 10px;"/>

  <div v-if="invalidEmail"
    class="signup-label signup-invalid"
    >
    {{__('Please use a valid email address.')}}
  </div>
  <div v-if="postSignup"
    class="signup-label signup-success"
    >
    {{__('Thank you! We will send an email to you with more information.')}}
  </div>
  <div v-if="signupFailed"
    class="signup-label signup-invalid"
    >
    {{__('Something went wrong. Please try again in a little while.')}}
  </div>

  <social-media
    v-if="socialMediaLinks === true"
    />
</div>
</template>
<script>

import SocialMedia from '@/components/elements/SocialMedia.vue'
import LineLoader from '@/components/elements/LineLoader.vue'
import emailCheck from 'script/emailCheck.js'
import api from '@/services/api.js'
import emailApi from '@/services/emailApi.js'
import bugsnag from 'services/bugsnag.js'
import analytics from 'services/analytics.js'

/*
const api = {
  signup: email => new Promise((resolve, reject) => {
    resolve('jepp')
  })
}
*/

export default {
  components: { LineLoader, SocialMedia },
  props: {
    socialMediaLinks: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      email: '',
      invalidEmail: false,
      postSignup: false,
      signupFailed: false,
      isPending: false
    }
  },
  watch: {
    email () {
      if (this.email !== '' && this.postSignup === true) {
        this.postSignup = false
      }
    }
  },
  methods: {
    enter (ev) {
      if (ev.keyCode === 13) {
        this.subscribe()
        this.$refs.inputField.blur()
        ev.preventDefault()
      }
    },
    subscribe () {
      this.invalidEmail = !emailCheck(this.email)

      if (!this.invalidEmail) {
        this.isPending = true

        api.signup(this.email)
          .then(() => {
            return emailApi.newSubscriber(this.email)
          })
          .then(() => {
            this.postSignup = true
            this.isPending = false
            this.email = ''

            analytics.signup()
          })
          .catch(err => {
            this.signupFailed = true
            this.isPending = false

            bugsnag.notify(err, {
              message: 'Can not sign up for news letter',
              email: this.email
            })
          })
      } else {
        this.$nextTick(() => {
          this.$refs.inputField.focus()
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .signup-form-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: auto;
  }

  .signup-form {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: center;
    width: 100%;
    max-width: 700px;

    @media (max-width: 400px) {
      flex-direction: column;
      align-items: stretch;
      justify-content: space-between;
    }
  }

  .signup-email {
    height: 30px;
    box-sizing: border-box;
    box-shadow: inset @shadow;
    border: none;
    margin-right: 10px;
    border-radius: 5px;
    display: flex;
    flex-grow: 1;
    padding-left: 10px;

    @media (max-width: 400px) {
      margin-right: 0px;
      margin-bottom: 10px;
    }
  }

  .signup-label {
    margin-top: 10px;
    margin-left: 10px;
    white-space: wrap;
    max-width: 250px;
  }

  .signup-success {
    color: @success-dark;
  }

  .signup-invalid {
    color: @warning-dark;
  }

</style>
